import React, {useContext, useEffect, useState} from 'react';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';
import {grey} from '@material-ui/core/colors';
import Button from '@material-ui/core/Button';
import {useCommonStyles} from '../../Styles';
import {
    ck_u_password,
    ck_u_username,
    defDateFormat,
    empty,
    oos_report_url,
	oos_report_url_v2,
    req_cust,
    req_cust_area,
    req_module_setting,
    req_report_oos,
    req_salesman,
    req_stock,
	req_report_oosreport,
	req_report_oosreport_uom,
	req_delete_file,
	req_cust_chain,
	req_report_oosoutletreport,
	req_stock_brand,
	req_settings_branches,
	req_cust_category
} from '../../Helper/Constants';
import _ from 'lodash';
import JString from '@easytech-international-sdn-bhd/jstring';
import API_Service, {axiosDefaultConfig, axiosURIencode} from '../../Services/API_Service';
import {useSnackbar} from 'notistack';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import DateRangePickerModal from '../../Components/DateRangePickerModal';
import moment from 'moment';
import VirtualListCB from '../../Components/VirtualListCB';
import format from 'date-fns/format';
import {de, getSetting} from '../../Helper/Helper';
import useCookieHook from "../../Services/useCookieHook";
import MUIDataTable from 'mui-datatables';
import useColumnPreference from '../../Services/useColumnPreference';
import {IconButton, Tooltip} from '@material-ui/core';
import {Assessment as AssessmentIcon} from '@material-ui/icons';
import GenerateView from '../../Components/GenerateView';

const useStyles = makeStyles((theme) => ({
	viewInRow: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'left',
		marginTop: theme.spacing(1),
		rowGap: 10
	}, card: {
		maxWidth: 200,
		minWidth: 200,
		marginRight: theme.spacing(1),
		marginTop: theme.spacing(1),
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightMedium,
	},
	textleft: {
		textAlign: "left"
	},
	dropzone: {
		width: '50%',
		borderRadius: 5
	},
	dropzoneText: {
		color: grey[600]
	},
	adverPaper: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		padding: theme.spacing(1.5)
	},
	adverView: {
		display: 'flex',
		flexWrap: 'wrap',
		padding: theme.spacing(1)
	},
	textarea: {
		width: '100%'
	},
	dateBtn: {
		width: '100%',
		marginTop: theme.spacing(1)
	},
	statusBtn: {
		marginLeft: 30,
		width: 150
	},
	row: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center'
	},
	alignRight: {
		display: 'flex',
		marginBottom: 10,
		flex: 1,
		flexDirection: 'row'
	}
}));

const tableHead = [
	{
		name: "created_date",
		label: "Stock Take Date",
		options: {
			display: true
		}
	},
	{
		name: "cust_code",
		label: "Outlet Code",
		options: {
			display: true
		}
	},
	{
		name: "cust_company_name",
		label: "Outlet Name",
		options: {
			display: true
		}
	},
	{
		name: "cust_category_name",
		label: "Outlet Category",
		options: {
			display: true
		}
	},
	{
		name: "cust_area",
		label: "Outlet Area",
		options: {
			display: true,
			customBodyRender: (value) => {
				if (value === "null" || value === null) {
					return "";
				}
				return value;
			}
		}
	},
	// {
	// 	name: "company",
	// 	label: "Branch",
	// 	options: {
	// 		display: true,
	// 		customBodyRender: (value) => value ? value.toUpperCase() : ''
	// 	}
	// },
	{
		name: "name",
		label: "Agent Name",
		options: {
			display: true
		}
	},
	{
		name: "staff_code",
		label: "Agent Code",
		options: {
			display: true
		}
	},
	{
		name: "prod_brand_name",
		label: "Product Brand",
		options: {
			display: true
		}
	},
	{
		name: "product_code",
		label: "Product Code",
		options: {
			display: true
		}
	},
	{
		name: "product_name",
		label: "Product Name",
		options: {
			display: true
		}
	},
	{
		name: "oos",
		label: "No. of Times OOS",
		options: {
			display: true
		}
	}
]

export default function ROOS() {
	const commonStyle = useCommonStyles();
	const classes = useStyles();

	const singleton = PersistantData.getInstance();
	const [gState, setGState] = useContext(AppContext);
	var {translation: language, client} = gState;
	if (typeof (language) === 'undefined') {
		language = singleton.getlang()
	}

	const [cookies, setCookie] = useCookieHook([ck_u_username, ck_u_password]);

	const {enqueueSnackbar, closeSnackbar} = useSnackbar();
	const [nClient, setClient] = useState(gState.client);

	const [splist, setSPlist] = useState([]);
	const [itemList, setItemList] = useState([]);
	const [outletList, setOutletList] = useState([]);
	const [oosList, setOosList] = useState([]);
	const [customerChainList, setCustomerChainList] = useState([]);
	const [customerCategoryList, setCustomerCategoryList] = useState([]);

	const [oosDocDateRange, setOosoosDocDateRange] = useState({});
	const [openOosDateDoc, setOpenOosDateDoc] = useState(false);
	const [oosSpView, setOosSpView] = useState(false);
	const [oosOutletView, setOosOutletView] = useState(false);
	const [oosItemView, setOosItemView] = useState(false);
	const [spOosSelect, setOosSpSelected] = useState(empty);
	const [oosSalesperson, setOosSalesperson] = useState(empty);
	const [oosOutletSelect, setOosOutletSelected] = useState(empty);
	const [oosOutlet, setOosOutlet] = useState(empty);
	const [selectedCustomerChain, setSelectedCustomerChain] = useState(empty);
	const [selectedCustomerChainValue, setSelectedCustomerChainValue] = useState(empty);
	const [selectedCustomerCategory, setSelectedCustomerCategory] = useState(empty);
	const [selectedCustomerCategoryValue, setSelectedCustomerCategoryValue] = useState(empty);
	const [oosItemSelect, setOosItemSelected] = useState(empty);
	const [oosItem, setOosItem] = useState(empty);
	const [tableHeader, setTableHeader] = useState([]);
	const { columns: preferredColumns, onColumnViewChange: onPrefColumnViewChange, isPreferenceLoaded } = useColumnPreference('ROOS', tableHeader, client);

	const [areaList, setAreaList] = useState([]);
	const [areaView, setAreaView] = useState(false);
	const [selectedArea, setSelectedArea] = useState(empty);
	const [printView, setPrintView] = useState();
	const [customerChainView, setCustomerChainView] = useState(false);
	const [customerCategoryView, setCustomerCategoryView] = useState(false);

	const [generateViewOptions, setGenerateViewOptions] = useState([
		{name: 'Basic Version', value: 'simply'},
		{name: 'Detailed Version', value: 'normal'},
		{name: 'UOM Convertion Version', value: 'normal_uom'}
	]);


	const [productBrandList, setProductBrandList] = useState([]);
	const [selectedProductBrand, setSelectedProductBrand] = useState(empty);
	const [selectedProductBrandValue, setSelectedProductBrandValue] = useState(empty);
	const [productBrandView, setProductBrandView] = useState(false);

	const [branchesList, setBranchesList] = useState([]);
	const [branchesView, setBranchesView] = useState(false);
	const [branchSelectedValue, setBranchSelectedValue] = useState(empty);
	const [branchSelectedName, setBranchSelectedName] = useState(empty);


	useEffect(() => {
		if (JString(gState.client).isValid()) {
			getSalesmanList(gState.client);
			getOutletList(gState.client);
			loadCustChainList(gState.client);
			loadCustCategoryList(gState.client);
			loadStocksList(gState.client);
			loadConfig(gState.client);
			getAreaList(gState._client);
			loadBrand(gState.client);
			getBranches(gState.client);
		}
		setTableHeader(tableHead);
	}, [gState.client, gState.translation]);

	const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	}

	const loadConfig = (_client = client) => {
		API_Service.get(req_module_setting, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result == 1) {
				const _config = getSetting(extraData, 'customization', {});
				const _modules = getSetting(extraData, 'modules', {});
				if(_modules.OOSReportOutletVersion){
					setGenerateViewOptions((prevState) => [
						...prevState, 
						{ name: 'Outlet Version', value: 'outlet' }
					]);
				}
        if (_modules['branch'] == true) {
					const branchExists = tableHead.some(column => column.name === "company");
					if (!branchExists) {
						tableHead.splice(5, 0, {
							name: "company",
							label: "Branch",
							options: {
								display: true,
								customBodyRender: (value) => value ? value.toUpperCase() : ''
							}
						});
					}
			}
		}});
	}

	const getAreaList = (_client = client) => {
		API_Service.get(req_cust_area, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (parseInt(result) === 1) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					const {area_name, area_code, area_status} = extraData[idx];
					_data.push({name: area_name, secondary: area_code, value: area_code, status: parseInt(area_status)});
				}
				setAreaList(_data);
			}
		});
	}

	const AreaViewClick = () => {
		setAreaView(true);
	}

	const AreaViewClose = (newValue) => {
		setAreaView(false);
		if (newValue) {
			var value = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
				} else {
					value += newValue[i].value + ",";
				}
			}
			setSelectedArea(value);
		}
	}

	const getOos = (_client = client) => {
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(oosDocDateRange)) {
			st_date = format(oosDocDateRange.startDate, defDateFormat);
			st_date_to = format(oosDocDateRange.endDate, defDateFormat);
		}
		var parameters = {
			client: client,
			date_from: st_date,
			date_to: st_date_to,
			salespersonId: spOosSelect,
			cust_code: oosOutletSelect,
			cust_chain_id: selectedCustomerChainValue,
			cust_category_id: selectedCustomerCategoryValue,
			product_code: oosItemSelect,
			prod_brand_id: selectedProductBrandValue,
			area: selectedArea,
			username: cookies(ck_u_username)
		};

		let formData = new FormData();
		formData.append('client', client);
		formData.append('date_from', st_date);
		formData.append('date_to', st_date_to);
		formData.append('salespersonId', spOosSelect);
		formData.append('cust_code', oosOutletSelect);
		formData.append('cust_chain_id', selectedCustomerChainValue);
		formData.append('product_code', oosItemSelect);
		formData.append('prod_brand_id', selectedProductBrandValue);
		formData.append('area', selectedArea);
		formData.append('username', cookies(ck_u_username));
		formData.append('cust_category_id', selectedCustomerCategoryValue);

		if (gState.company) {
			parameters.company = gState.company;
			formData.append('company', gState.company);
		}
		if (branchSelectedValue !== empty) {
			parameters.company = JSON.stringify(branchSelectedValue.split(","));
			formData.append('company', JSON.stringify(branchSelectedValue.split(",")));
		}
		const param = axiosURIencode(parameters);
		// API_Service.get(`${req_report_oos}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
		API_Service.post(req_report_oos, formData, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					var _arr = extraData[idx];
					if (_arr['checkin_time']) {
						_arr['checkin_date'] = moment(_arr['checkin_time']).format('DD/MM/YYYY');
						_arr['checkin_time'] = moment(_arr['checkin_time']).format('HH:mmA');
					}
					if (_arr['checkout_time']) {
						_arr['checkout_date'] = moment(_arr['checkout_date']).format('DD/MM/YYYY');
						_arr['checkout_time'] = moment(_arr['checkout_time']).format('HH:mmA');
					}
					if (_arr['status'] === '1') {
						_arr['status'] = "In Progress";
					} else if (_arr['status'] === '2') {
						_arr['status'] = "Completed";
					}
					_arr['created_date'] = moment(_arr['created_date']).format('DD/MM/YYYY');
					_arr['checkout_coordinates'] = _arr['checkout_lat'] + ',' + _arr['checkout_lng'];
					_data.push(_arr);
				}
				setOosList(oosList => (_data));
			} else {
				setOosList(oosList => ([]));
				snack(language.no_data, 'warning');
			}
		});
	}

	const getSalesmanList = (_client = nClient) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_salesman}${parameters}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					const {name, login_id, login, login_status} = extraData[idx];
					_data.push({name: name, secondary: login, value: login_id, status: parseInt(login_status)});
				}
				setSPlist(splist => (_data));
			} else {
				snack(gState.translation.not_found_salesperson, 'warning');
			}
		});
	}

	const getOutletList = (_client = nClient) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_cust}${parameters}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			var {customer, inactive_customer} = extraData;
			if (parseInt(result) === 1) {
				var arr = [];
				for (let i = 0; i < customer.length; i++) {
					const {cust_code, cust_company_name} = customer[i];
					arr.push({
						name: cust_company_name,
						secondary: cust_code,
						value: cust_code,
						status: 1
					});
				}
				for (let i = 0; i < inactive_customer.length; i++) {
					const {cust_code, cust_company_name} = inactive_customer[i];
					arr.push({
						name: cust_company_name,
						secondary: cust_code,
						value: cust_code,
						status: 0
					});
				}
				arr.unshift({
					name: "*Customer Not in List*",
					secondary: "CHECK-IN CODE",
					value: "CHECK-IN CODE",
					status: 1
				});
				setOutletList(arr);
			}
		});
	}

	const loadCustChainList = (_client = client) => {
		API_Service.get(req_cust_chain, axiosDefaultConfig(_client)).then(({data}) => {
			if (data) {
				var {result, extraData } = data;
				if (parseInt(result) === 1) {
					var _arr = [];
					for (let i = 0; i < extraData.length; i++) {
						const {cust_chain_id, cust_chain_code, cust_chain_name, cust_chain_status} = extraData[i];
						if (parseInt(cust_chain_status) === 1) {
							_arr.push({
								name: cust_chain_name,
								secondary: cust_chain_code,
								value: cust_chain_id,
								status: 1
							});
						}else{
							_arr.push({
								name: cust_chain_name,
								secondary: cust_chain_code,
								value: cust_chain_id,
								status: 0
							});
						}
					}
					setCustomerChainList(() => (_arr));
				}
			}
		}).catch(err => de(err.message, 'customer chain list'));
	}

	const loadCustCategoryList = (_client = client) => {
		API_Service.get(req_cust_category, axiosDefaultConfig(_client)).then(({data}) => {
			if (data) {
				var {result, extraData } = data;
				if (parseInt(result) === 1) {
					var _arr = [];
					for (let i = 0; i < extraData.length; i++) {
						const {cust_category_id, cust_category_code, cust_category_name, cust_category_status} = extraData[i];
						if (parseInt(cust_category_status) === 1) {
							_arr.push({
								name: cust_category_name,
								secondary: cust_category_code,
								value: cust_category_id,
								status: 1
							});
						} else {
							_arr.push({
								name: cust_category_name,
								secondary: cust_category_code,
								value: cust_category_id,
								status: 0
							});
						}
					}
					setCustomerCategoryList(() => (_arr));
				}
			}
		}).catch(err => de(err.message, 'customer category list'));
	}

	const loadStocksList = (_client = nClient) => {
		var req = `${req_stock}-1`;
		API_Service.get(req, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			const {stock: stockApi} = extraData;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < stockApi.length; idx++) {
					const {product_name, product_code, product_status} = stockApi[idx];
					_data.push({name: product_name, secondary: product_code, value: product_code, status: parseInt(product_status)});
				}
				setItemList(itemList => (_data));
			}
			de(data);
		}).catch(de);
	}


	const loadBrand = (_client = client) => {
		API_Service.get(req_stock_brand, axiosDefaultConfig(_client)).then(({data}) => {
			var _arr = [];
			if (!_.isEmpty(data)) {
				for (let idx = 0; idx < data.length; idx++) {
					const {brand_id, brand_code, brand_name, brand_status} = data[idx];
					if (parseInt(brand_status) === 1) {
						_arr.push({
							name: brand_name,
							secondary: brand_code,
							value: brand_id,
							status: 1
						});
					} else {
						_arr.push({
							name: brand_name,
							secondary: brand_code,
							value: brand_id,
							status: 0
						});
					}
				}
			}
			setProductBrandList(() => (_arr));
		});
  }
  
	const getBranches = (_client = client) => {
		API_Service.get(req_settings_branches, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				setBranchesList(branchesList => (extraData));
			}
		}).catch(de);
	}

	const OosSpViewClick = () => {
		setOosSpView(true);
	}

	const OosOutletViewClick = () => {
		setOosOutletView(true);
	}

	const OosSpViewClose = (newValue) => {
		setOosSpView(false);
		if (newValue) {
			var spvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spvalue += newValue[i].value;
				} else {
					spvalue += newValue[i].value + ",";
				}
			}
			setOosSpSelected(spvalue);

			var spname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spname += newValue[i].name;
				} else {
					spname += newValue[i].name + ",";
				}
			}
			setOosSalesperson(spname);
		}
	}

	const OosOutletViewClose = (newValue) => {
		setOosOutletView(false);
		if (newValue) {
			var outletvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					outletvalue += newValue[i].value;
				} else {
					outletvalue += newValue[i].value + ",";
				}
			}
			setOosOutletSelected(outletvalue);

			var outletname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					outletname += newValue[i].name;
				} else {
					outletname += newValue[i].name + ",";
				}
			}
			setOosOutlet(outletname);
		}
	}

	const OnCloseCustomerChainView = (data) => {
		setCustomerChainView(false);
		if (data) {
			var itemsvalue = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsvalue += data[i].value;
				} else {
					itemsvalue += data[i].value + ",";
				}
			}
			setSelectedCustomerChainValue(itemsvalue);

			var itemsname = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsname += data[i].name;
				} else {
					itemsname += data[i].name + ",";
				}
			}
			setSelectedCustomerChain(itemsname);
		}
	}

	const OnCloseCustomerCategoryView = (data) => {
		setCustomerCategoryView(false);
		if (data) {
			var itemsvalue = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsvalue += data[i].value;
				} else {
					itemsvalue += data[i].value + ",";
				}
			}
			setSelectedCustomerCategoryValue(itemsvalue);

			var itemsname = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsname += data[i].name;
				} else {
					itemsname += data[i].name + ",";
				}
			}
			setSelectedCustomerCategory(itemsname);
		}
	}

	const OosItemViewClick = () => {
		setOosItemView(true);
	}

	const OosItemViewClose = (newValue) => {
		setOosItemView(false);
		if (newValue) {
			var itemvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					itemvalue += newValue[i].value;
				} else {
					itemvalue += newValue[i].value + ",";
				}
			}
			setOosItemSelected(itemvalue);

			var item = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					item += newValue[i].name;
				} else {
					item += newValue[i].name + ",";
				}
			}
			setOosItem(item);
		}
	}

	const getOosDate = () => {
		return !_.isEmpty(oosDocDateRange) ? moment(oosDocDateRange.startDate).format('DD MMMM YYYY') + " / " + moment(oosDocDateRange.endDate).format('DD MMMM YYYY') : moment(new Date()).format('DD MMMM YYYY') + " / " + moment(new Date()).format('DD MMMM YYYY');
	}

	const openPrintSelectView = () => {
		setPrintView(true);
	}

	const printViewClose = (type) => {
		generateOosReport(type);
		setPrintView(false);
	}

	const generateOosReport = (type, _client = client) => {
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(oosDocDateRange)) {
			st_date = format(oosDocDateRange.startDate, defDateFormat);
			st_date_to = format(oosDocDateRange.endDate, defDateFormat);
		}
		let formData = new FormData();
		var parameters = {
			date_from: st_date,
			date_to: st_date_to,
			salespersonId: spOosSelect,
			cust_code: oosOutletSelect,
			cust_chain_id: selectedCustomerChainValue,
			cust_category_id: selectedCustomerCategoryValue,
			product_code: oosItemSelect,
			area: selectedArea,
			prod_brand_id: selectedProductBrandValue,
		};
		formData.append('date_from', st_date);
		formData.append('date_to', st_date_to);
		formData.append('salespersonId', spOosSelect);
		formData.append('cust_code', oosOutletSelect);
		formData.append('cust_chain_id', selectedCustomerChainValue);
		formData.append('cust_category_id', selectedCustomerCategoryValue);
		formData.append('area', selectedArea);
		formData.append('prod_brand_id', selectedProductBrandValue);
		formData.append('product_code', oosItemSelect);
		if (gState.company) {
			parameters.company = gState.company;
			formData.append('company', gState.company);
		}
		if (branchSelectedValue !== empty) {
			parameters.company = JSON.stringify(branchSelectedValue.split(","));
			formData.append('company', JSON.stringify(branchSelectedValue.split(",")));
		}
		const param = axiosURIencode(parameters);
		// if (type == 'simply') {
		// 	const date_range = `${st_date} to ${st_date_to}`;
		// 	let branch = gState.company ? gState.company : '';
		// 	if (branchSelectedValue !== empty) {
		// 		branch = JSON.stringify(branchSelectedValue.split(","));
		// 	}
		// 	var link = JString(oos_report_url)
		// 		.replaceInfinity('@client', client)
		// 		.replaceInfinity('@reportDate', encodeURIComponent(date_range))
		// 		.replaceInfinity('@salespersonId', spOosSelect)
		// 		.replaceInfinity('@cust_code', oosOutletSelect)
		// 		.replaceInfinity('@cust_chain_id', selectedCustomerChainValue)
		// 		.replaceInfinity('@area', selectedArea)
		// 		.replaceInfinity('@branch', branch)
		// 		.replaceInfinity('@username', cookies(ck_u_username))
		// 		.replaceInfinity('@product_code', oosItemSelect)
		// 		.replaceInfinity('@prod_brand_id', selectedProductBrandValue)
		// 		.str;
		// 	window.open(link, "_blank");
		// }
		if (type == 'simply') {
			const date_range = `${st_date} to ${st_date_to}`;
			let branch = gState.company ? gState.company : '';
			if (branchSelectedValue !== empty) {
				branch = JSON.stringify(branchSelectedValue.split(","));
			}
			
			// 创建隐藏表单进行 POST 提交
			const form = document.createElement('form');
			form.method = 'POST';
			form.action = oos_report_url_v2;
			form.target = '_blank';
			form.style.display = 'none';
			
			// 添加表单字段
			const fields = {
				client: client,
				reportDate: date_range,
				salespersonId: spOosSelect,
				cust_code: oosOutletSelect,
				cust_chain_id: selectedCustomerChainValue,
				area: selectedArea,
				branch: branch,
				username: cookies(ck_u_username),
				product_code: oosItemSelect,
				prod_brand_id: selectedProductBrandValue,
				cust_category_id: selectedCustomerCategoryValue
			};

			Object.keys(fields).forEach(key => {
				// if (fields[key] !== empty && fields[key] !== null && fields[key] !== undefined) {
					const input = document.createElement('input');
					input.type = 'hidden';
					input.name = key;
					input.value = fields[key];
					form.appendChild(input);
				// }
			});

			document.body.appendChild(form);
			form.submit();
			document.body.removeChild(form);
		}

		if (type == 'normal') {
			// API_Service.get(`${req_report_oosreport}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			API_Service.post(`${req_report_oosreport}`, formData, axiosDefaultConfig(_client)).then(({data}) => {
				const {result, extraData} = data;
				if (result) {
					window.open(extraData.url, '_blank');
					const delay = setTimeout(() => {
						API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
						clearTimeout(delay);
					}, 5000);
				} else {
					snack(language.no_data, 'warning');
				}
			}).catch(err => {
				snack('The data is too large, please simplify the requirements', 'warning');
			});
		}

		if (type == 'normal_uom') {
			API_Service.post(`${req_report_oosreport_uom}`, formData, axiosDefaultConfig(_client)).then(({data}) => {
				const {result, extraData} = data;
				if (result) {
					window.open(extraData.url, '_blank');
					const delay = setTimeout(() => {
						API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
						clearTimeout(delay);
					}, 5000);
				} else {
					snack(language.no_data, 'warning');
				}
			}).catch(err => {
				snack('The data is too large, please simplify the requirements', 'warning');
			});
		}



		if (type == 'outlet') {
			API_Service.get(`${req_report_oosoutletreport}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
				const {result, extraData} = data;
				if (result) {
					window.open(extraData.url, '_blank');
					const delay = setTimeout(() => {
						API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
						clearTimeout(delay);
					}, 5000);
				} else {
					snack(language.no_data, 'warning');
				}
			}).catch(err => {
				snack('The data is too large, please simplify the requirements', 'warning');
			});
		}
	}


	const OnCloseProductBrandView = (data) => {
		setProductBrandView(false);
		if (data) {
			var itemsvalue = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsvalue += data[i].value;
				} else {
					itemsvalue += data[i].value + ",";
				}
			}
			setSelectedProductBrandValue(itemsvalue);

			var itemsname = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsname += data[i].name;
				} else {
					itemsname += data[i].name + ",";
				}
			}
			setSelectedProductBrand(itemsname);
    }
  }

	const BranchesViewClose = (newValue) => {
		setBranchesView(false);
		if (newValue) {
			var value = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
				} else {
					value += newValue[i].value + ",";
				}
			}
			setBranchSelectedValue(value);

			var name = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					name += newValue[i].name;
				} else {
					name += newValue[i].name + ",";
				}
			}
			setBranchSelectedName(name);
		}
	}

	return (
		<div>
			{/* <Typography className={classes.heading}>{ language.generate_oos_report }</Typography> */}
			<div className={classes.viewInRow}>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => OosSpViewClick()}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{oosSalesperson ? _.truncate(oosSalesperson, {length: 20}) : language.salesperson}
					</Typography>
				</Button>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => OosOutletViewClick()}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{oosOutlet ? _.truncate(oosOutlet, {length: 20}) : language.customer}
					</Typography>
				</Button>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setCustomerCategoryView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedCustomerCategory ? _.truncate(selectedCustomerCategory, {length: 20}) : "Outlet Category"}
					</Typography>
				</Button>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setCustomerChainView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedCustomerChain ? _.truncate(selectedCustomerChain, {length: 20}) : "Outlet Chain"}
					</Typography>
				</Button>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setProductBrandView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedProductBrand ? _.truncate(selectedProductBrand, {length: 20}) : "Item Brand"}
					</Typography>
				</Button>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => AreaViewClick()}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedArea ? _.truncate(selectedArea, {length: 20}) : "Area"}
					</Typography>
				</Button>
				{
					!gState.company && branchesList.length > 0 && (
						<Button
							style={{width: 300, marginRight: 10}}
							variant="outlined"
							onClick={() => setBranchesView(true)}
							endIcon={<KeyboardArrowDownRoundedIcon/>}>
							<Typography className={commonStyle.searchBtnFont}>
								{branchSelectedName ? _.truncate(branchSelectedName, {length: 20}) : "Branch"}
							</Typography>
						</Button>
					)
				}
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => OosItemViewClick()}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{oosItem ? _.truncate(oosItem, {length: 20}) : language.items}
					</Typography>
				</Button>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setOpenOosDateDoc(true)}>
					<Typography className={commonStyle.searchBtnFont}>
						{getOosDate()}
					</Typography>
				</Button>
				<Button
					size="small"
					color="primary"
					variant={'contained'}
					onClick={() => getOos()}>
					<Typography className={commonStyle.searchBtnFont}>
						{language.view}
					</Typography>
				</Button>
			</div>
			<div style={{height: 20}}/>
			{
				oosList.length > 0 && (
					<MUIDataTable
						title={language.oos}
						data={oosList}
						columns={preferredColumns}
						options={{
							search: false,
							print: false,
							filter: false,
							download: false,
							selectableRows: 'none',
							rowsPerPage: 25,
							rowsPerPageOptions: [25, 40, 65, 100],
							responsive: 'simple',
							onColumnViewChange: onPrefColumnViewChange,
							customToolbar: () =>
								<>
									<CheckinTableReportButton onGenerateReport={openPrintSelectView}/>
								</>
						}}
					/>
				)
			}

			<VirtualListCB
				open={oosSpView}
				setClose={data => OosSpViewClose(data)}
				title={language.salesperson}
				data={splist}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={oosOutletView}
				setClose={data => OosOutletViewClose(data)}
				title={"Outlet"}
				data={outletList}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={oosItemView}
				setClose={data => OosItemViewClose(data)}
				title={"Item"}
				data={itemList}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={areaView}
				setClose={data => AreaViewClose(data)}
				title={"Area"}
				data={areaList}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={customerChainView}
				setClose={data => OnCloseCustomerChainView(data)}
				title={"Outlet Chain"}
				data={customerChainList}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={customerCategoryView}
				setClose={data => OnCloseCustomerCategoryView(data)}
				title={"Outlet Category"}
				data={customerCategoryList}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={productBrandView}
				setClose={data => OnCloseProductBrandView(data)}
				title={"Product Brand"}
				data={productBrandList}
				language={language}
				filteration={1}
			/>

      <VirtualListCB
				open={branchesView}
				setClose={data => BranchesViewClose(data)}
				title={"Branch"}
				data={branchesList}
				language={language}
				filteration={0}
			/>

			<DateRangePickerModal
				setPositive={range => {
					setOosoosDocDateRange(range);
					setOpenOosDateDoc(false)
				}}
				setNegative={() => {
					setOpenOosDateDoc(false)
				}}
				setClose={() => {
					setOpenOosDateDoc(false)
				}}
				open={openOosDateDoc}
				message={language.date_range}
				positive={language.ok}
				negative={language.cancel}
			/>

			<GenerateView
				classes={{
					paper: commonStyle.listView,
				}}
				id="ringtone-menu"
				keepMounted
				open={printView}
				onClose={() => setPrintView(false)}
				onSelect={printViewClose}
				value={'simply'}
				title={language.generate_type || ''}
				language={language}
				options={generateViewOptions}
			/>
		</div>
	)
}

function CheckinTableReportButton({onGenerateReport}) {
	return (
		<React.Fragment>
			<Tooltip title={'Generate Report'}>
				<IconButton
					edge={'end'}
					color={'primary'}
					onClick={() => onGenerateReport()} aria-label="addnew">
					<AssessmentIcon/>
				</IconButton>
			</Tooltip>
		</React.Fragment>
	)
}
